export const refreshAndClose = (refresh: () => void, close: () => void) => {
	return () => {
		refresh()
		close()
	}
}
